import React from 'react';
import styled from '@emotion/styled';
import { ITheme, StyledBaseChip } from '../../../../../ui';
import { withTranslate } from '../../../../shared/i18n/translate';
import { getTranslationKeyForStatus } from './getTranslationKeyForStatus';
import { IFlightPublicStatus } from '../domain/models/IFlightPublicStatus';
import { getColorForFlightStatus } from './getColorForFlightStatus';
import themed from '../../../../../ui/themer/themed';

interface IStyledStatusProps {
	status?: IFlightPublicStatus;
}

export const StyledStatus = styled(StyledBaseChip)<IStyledStatusProps, ITheme>`
	background: ${themed<Partial<IProps>>((theme, { status }) =>
		status ? getColorForFlightStatus(status, theme) : '',
	)};
	color: ${themed(({ color }) => color.text.inverted)};
`;

interface IProps {
	status: IFlightPublicStatus;
}

export const StatusLabel = withTranslate<IProps>(({ t, status }) => {
	const translationKey = getTranslationKeyForStatus(status);

	return (
		<StyledStatus status={status}>
			{translationKey ? t(translationKey) : status}
		</StyledStatus>
	);
});
